import React from "react";
import { Card, CardTitle } from "../ui/Card";
import RadioGroup from "../ui/RadioGroup";
import { SUBMITTER_TYPE_OPTIONS } from "../options";

/*
The first question on the form - decides which fields are asked. A customer's
primary email is always their own; retailers choose it in PrimaryEmailSection.
Defaults to "Customer".
*/
export default function SubmitterTypeSection({ value, onChange }) {
  return (
    <Card radius="panel" className="rma-nc-card--compact">
      <CardTitle
        className="rma-nc-card-title-row--flush"
        aside={
          <RadioGroup
            name="submitter-type"
            options={SUBMITTER_TYPE_OPTIONS}
            value={value}
            onChange={onChange}
          />
        }
      >
        Who is submitting this request?
      </CardTitle>
    </Card>
  );
}
